<template>
  <div class="email-display">
    <div class="row">
      <label class="col-sm-4 control-label">{{ field.label }}</label>
      <div class="col-sm-8"><a v-bind:href="'mailto:' + field.value">{{ field.value }}</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailDisplay',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// EmailDisplay.vue?0473668a